import { IDS } from '../improvement-action-id.constants';
import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import * as Actions from '../improvement.actions';

class AddActionStepsGridController extends GridController {
    constructor($ngRedux,
                $state,
                NavigationService,
                AuthService,
                FileActions,
                $filter,
                $mdDialog,
                $scope
    ) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.rcoImprovement;
        this.statePath = IDS.improvementStepsGrid;
        this.autoload = false;
        // this.filterControls = false;
        this.filterComponent = false;
        this.exportComponent = false;
        this.filterExpandButtonVisible = false
        // this.filterComponent = false;
        // this.header = false;
        this.icon = false;
        this.title = 'Action Plan';

        const user = this.AuthService.getUser();
        this.isAdmin = user.type === 'Administrator';
        this.basicTypeName = user.basicTypeName;
        this.columns = [
            {title: '#', mapper: null},
            {title: 'Task',                                                     mapper: 'title'},
            {title: this.$filter('translate')('COMMON.FIELD.ASSIGNEE'),         mapper: 'assignee'},
            {title: 'Requirement',                                              mapper: 'requirement_name'},
            {title: 'Evidence',                                                 mapper: 'evidence_name'},
            {title: this.$filter('translate')('COMMON.DATE.DUE_DATE'),          mapper: 'due_date'},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), {...Actions, ...this.FileActions})(this);

        // this.buttons = [
        //     {label: 'Details', class: 'btnGridModify', callback: this.onSelect}
        // ];
        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

AddActionStepsGridController.$inject = ['$ngRedux', '$state', 'NavigationService', 'AuthService', 'FileActions','$filter', '$mdDialog', '$scope'];

export const addActionStepsGrid = {
    bindings: {
        adoId: '<',
        onRemove: '&',
        // onSelect: '&',
    },
    controller: AddActionStepsGridController,
    ...gridTpl
}
